import { DatePicker, Drawer, Input, message, Select, Spin } from "antd";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { svg } from "../../../../Assets/svg";
import {
  CapitalizeFirstWord,
  momentDDMMYY,
  ROLE,
  UniqueByIdForDropdown,
  useDebounce,
} from "../../../../helpers/utils";
import { GetTeamMemberListAPI } from "../../../Redux/teamMember";
import { RootState, useAppDispatch, useAppSelector } from "../../../../store";
import { decryptByText } from "../../../../helpers/bycrypt";
import { BtnLoader } from "../../../../Components/Components";

const EditLabelDataDrawer = ({
  isOpen,
  setIsOpen,
  dymo,
  previewImage,
  setPreviewImage,
  activeDepartmentSlug,
  activeKey,
}: any) => {
  console.log(previewImage, "previewImagepreviewImagepreviewImage");
  const dispatch = useAppDispatch();
  const onClose = () => {
    setIsOpen(false);
  };
  const { teamMemberList } = useAppSelector(
    (state: RootState) => state.teamMember,
  );

  const { getTeamMemberLoading } = useAppSelector(
    (state: RootState) => state.loading,
  );
  const initialDate: any = previewImage?.find(
    (elem: any) => elem?.label_data?.printed_data?.extra_data?.date,
  )?.label_data?.printed_data?.extra_data?.date;

  const [selectedDate, setSelectedDate] = useState<Date>(() => {
    const parsed = initialDate ? new Date(initialDate) : null;
    return parsed && !isNaN(parsed.getTime()) ? parsed : new Date();
  });
  const [selectDeleveryStatus, setSelectDeleveryStatus] = useState(
    previewImage?.find(
      (elem: any) =>
        elem?.label_data?.printed_data?.extra_data?.collection_status,
    )?.label_data?.printed_data?.extra_data?.collection_status || null,
  );
  const [dispatchMemberPage, setDispatchMemberPage] = useState(1);
  const [hasMoreDispatchMember, setHasMoreDispatchMember] = useState(true);
  const [dispatchMemberSearch, setDispatchMemberSearch] = useState("");
  const debouncedDispatchMemberSearch = useDebounce(dispatchMemberSearch, 300);
  const [selectedDispatchUser, setSelectedDispatchUser] = useState(
    previewImage?.find(
      (elem: any) => elem?.label_data?.printed_data?.extra_data?.dispatch_user,
    )?.label_data?.printed_data?.extra_data?.dispatch_user?._id || null,
  );
  const [editedQty, setEditedQty] = useState(
    previewImage?.find(
      (elem: any) => elem?.label_data?.printed_data?.extra_data,
    )?.label_data?.printed_data?.extra_data?.quantity ||
      previewImage?.[0]?.qty ||
      1,
  );
  const [editedBatchesQty, setEditedBatchesQty] = useState(
    previewImage?.find(
      (elem: any) => elem?.label_data?.printed_data?.extra_data,
    )?.label_data?.printed_data?.extra_data?.number_of_batches || 1,
  );

  const [changeLoader, setChangeLoader] = useState(false);
  const teamPayload = useMemo(
    () => ({
      page: dispatchMemberPage,
      limit: 15,
      search: debouncedDispatchMemberSearch,
      roleKey: [ROLE.DISPATCH, ROLE.DISPATCH_MANAGER],
    }),
    [dispatchMemberPage, debouncedDispatchMemberSearch],
  );

  useEffect(() => {
    dispatch(GetTeamMemberListAPI(teamPayload, setHasMoreDispatchMember));
  }, [dispatch, teamPayload]);

  const employeeOptions = useMemo(() => {
    const foundUser = previewImage?.find(
      (elem: any) => elem?.label_data?.printed_data?.extra_data?.dispatch_user,
    )?.label_data?.printed_data?.extra_data?.dispatch_user;

    return UniqueByIdForDropdown([
      ...(foundUser ? [foundUser] : []),
      ...teamMemberList,
    ]);
  }, [previewImage, teamMemberList]);

  const handleInstallationManageSearch = useCallback((value: string) => {
    setDispatchMemberSearch(value);
    setDispatchMemberPage(1);
    setHasMoreDispatchMember(true);
  }, []);

  const handleInstallationManageScroll = useCallback(
    (event: any) => {
      const target = event.target;
      if (
        !getTeamMemberLoading &&
        hasMoreDispatchMember &&
        Math.abs(
          target.scrollHeight - (target.scrollTop + target.offsetHeight),
        ) < 2
      ) {
        setDispatchMemberPage((prev) => prev + 1);
      }
    },
    [getTeamMemberLoading, hasMoreDispatchMember],
  );

  const handleChange = async () => {
    const findedUser: any = employeeOptions?.find(
      (elem: any) => elem?._id == selectedDispatchUser,
    );
    if (selectedDispatchUser || selectedDate || editedQty || editedBatchesQty) {
      setChangeLoader(true);
      const updated = await Promise.all(
        previewImage?.map(async (elem: any) => {
          if (!elem?.selected) return elem;

          let replacedData = elem?.XML || "";

          const extraData = elem?.label_data?.printed_data?.extra_data || {};

          // 👤 USER REPLACEMENT
          if (selectedDispatchUser) {
            const oldUser = extraData?.dispatch_user?.name || "{{PACKED_BY}}";

            const newUser = findedUser?.name || "";

            replacedData = replacedData.replaceAll(oldUser, newUser);
          }

          // 📅 DATE REPLACEMENT
          if (selectedDate) {
            const oldDate = extraData?.date
              ? momentDDMMYY(new Date(extraData.date))
              : momentDDMMYY(new Date());

            const newDate = momentDDMMYY(new Date(selectedDate));

            replacedData = replacedData.replaceAll(oldDate, newDate);
          }

          if (selectDeleveryStatus) {
            if (selectDeleveryStatus == "delivery") {
              if (extraData?.collection_status == "delivery") {
                replacedData = replacedData.replace(
                  `<Color A="1"          R="0" G="0" B="0"></Color>`,
                  `<Color A="1"          R="0" G="0" B="0"></Color>`,
                );
                replacedData = replacedData.replace(
                  `<Color A="1"     R="0" G="0" B="0"></Color>`,
                  `<Color A="0"     R="0" G="0" B="0"></Color>`,
                );
              } else {
                replacedData = replacedData.replace(
                  `<Color A="0"          R="0" G="0" B="0"></Color>`,
                  `<Color A="1"          R="0" G="0" B="0"></Color>`,
                );
                replacedData = replacedData.replace(
                  `<Color A="1"     R="0" G="0" B="0"></Color>`,
                  `<Color A="0"     R="0" G="0" B="0"></Color>`,
                );
              }
            } else if (selectDeleveryStatus == "collection") {
              if (extraData?.collection_status == "collection") {
                replacedData = replacedData.replace(
                  `<Color A="1"     R="0" G="0" B="0"></Color>`,
                  `<Color A="1"     R="0" G="0" B="0"></Color>`,
                );
                replacedData = replacedData.replace(
                  `<Color A="1"          R="0" G="0" B="0"></Color>`,
                  `<Color A="0"          R="0" G="0" B="0"></Color>`,
                );
              } else {
                replacedData = replacedData.replace(
                  `<Color A="0"     R="0" G="0" B="0"></Color>`,
                  `<Color A="1"     R="0" G="0" B="0"></Color>`,
                );
                replacedData = replacedData.replace(
                  `<Color A="1"          R="0" G="0" B="0"></Color>`,
                  `<Color A="0"          R="0" G="0" B="0"></Color>`,
                );
              }
            }
          }
          if (Number(editedQty)) {
            const oldData = extraData?.quantity
              ? `TOTAL QUANTITY - ${extraData?.quantity}`
              : `TOTAL QUANTITY - ${elem?.label_data?.qty}`;
            const newData = `TOTAL QUANTITY - ${editedQty}`;
            replacedData = replacedData.replaceAll(oldData, newData);
          }
          if (Number(editedBatchesQty)) {
            const newBatchQty = Math.ceil(
              Number(editedQty) / Number(editedBatchesQty),
            );
            const oldData = extraData?.number_of_batches
              ? `BATCH QUANTITY - ${extraData?.number_of_batches}`
              : `BATCH QUANTITY - {{B_QUANTITY}}`;
            const newData = `BATCH QUANTITY - ${newBatchQty}`;
            replacedData = replacedData.replaceAll(oldData, newData);
          }
          // 🖨️ RENDER LABEL
          const result = await dymo.renderLabel(replacedData);

          let base64: any = typeof result === "object" ? result?.data : result;

          if (!base64) return elem;

          base64 = base64.replace(/"/g, "");

          const baseData = base64.startsWith("data:image")
            ? base64
            : `data:image/png;base64,${base64}`;

          return {
            ...elem,
            XML: replacedData,
            preview: baseData,
            copies: editedBatchesQty ? Number(editedBatchesQty) : 1,
            label_data: {
              ...elem?.label_data,
              printed_data: {
                ...(elem?.label_data?.printed_data || {}),
                extra_data: {
                  date: selectedDate ? new Date(selectedDate) : null,
                  dispatch_user: findedUser || null,
                  collection_status: selectDeleveryStatus || null,
                  quantity: Number(editedQty),
                  number_of_batches: editedBatchesQty
                    ? Number(editedBatchesQty)
                    : 1,
                  batch_qauntity:
                    editedQty && editedBatchesQty
                      ? Math.ceil(editedQty / editedBatchesQty)
                      : 1,
                },
              },
            },
          };
        }),
      );
      setPreviewImage(updated);
      setChangeLoader(false);
      message.success("Labels Updated Successfully");
      onClose();
    } else {
      onClose();
    }
  };
  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      title="Edit Label Data"
      className="safe-area"
      maskClosable={true}
      width={420}
      styles={{ body: { display: "flex", flexDirection: "column" } }}
      extra={null}
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={changeLoader}
          >
            CLOSE
          </button>
          <button
            onClick={handleChange}
            className={`btn btn-lg min-w-130 btn-primary`}
            disabled={changeLoader}
          >
            {changeLoader ? <BtnLoader /> : "CHANGE"}
          </button>
        </div>
      }
    >
      <div className="page-form">
        <div className="row gy-3 mb-4">
          {activeDepartmentSlug == "sheet-metal" ? (
            <p className="fs-6 mb-0">
              <span className="fw-bold">*Notes :</span>Fields with zero or empty
              values are ignored during label data updates.
            </p>
          ) : (
            ""
          )}
          {activeDepartmentSlug == "picking-packing" ||
          activeKey == "dispatch" ? (
            <>
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="">Date</label>
                  <DatePicker
                    style={{ width: "100%" }}
                    format="DD/MM/YYYY"
                    value={selectedDate ? dayjs(selectedDate) : null}
                    onChange={(date: any) => setSelectedDate(date)}
                    className="form-control form-control-lg"
                    suffixIcon={svg?.dateIcon}
                    placeholder="DD/MM/YYYY"
                    allowClear={false}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-item">
                  <label className="custom-label mb-1 ff">Packed By</label>
                  <Select
                    placeholder="Search"
                    // mode="multiple"
                    // maxTagCount="responsive"
                    // allowClear
                    showSearch
                    filterOption={false}
                    rootClassName="multipleSelect"
                    onSearch={handleInstallationManageSearch}
                    onPopupScroll={handleInstallationManageScroll}
                    notFoundContent={
                      getTeamMemberLoading ? (
                        <div className="text-center p-2">
                          <Spin size="small" />
                        </div>
                      ) : (
                        <div className="text-center p-2 text-secondary">
                          No any user found
                        </div>
                      )
                    }
                    value={selectedDispatchUser || null}
                    onChange={(value: any) => {
                      setSelectedDispatchUser(value);
                    }}
                    options={
                      employeeOptions?.map((d: any) => ({
                        label: d.name,
                        value: d._id,
                      })) || []
                    }
                    suffixIcon={svg?.selectDownArrow}
                    className="w-100"
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-item">
                  <label className="custom-label mb-1 ff">Delevery Type</label>
                  <Select
                    placeholder="Select"
                    showSearch
                    filterOption={false}
                    onSearch={handleInstallationManageSearch}
                    onPopupScroll={handleInstallationManageScroll}
                    value={selectDeleveryStatus || null}
                    onChange={(value: any) => {
                      setSelectDeleveryStatus(value);
                    }}
                    options={[
                      {
                        label: "DELIVERY",
                        value: "delivery",
                      },
                      {
                        label: "COLLECTION",
                        value: "collection",
                      },
                    ]}
                    suffixIcon={svg?.selectDownArrow}
                    className="w-100"
                  />
                </div>
              </div>
            </>
          ) : activeDepartmentSlug == "sheet-metal" ? (
            <>
              <div className="col-md-12">
                <div className="form-item">
                  <label className="custom-label mb-1 ff d-flex align-items-center justify-content-between">
                    Quantity
                  </label>
                  <Input
                    name="qty"
                    type="number"
                    min={1}
                    value={editedQty}
                    className="form-control form-control-lg"
                    placeholder={"Enter Quantity"}
                    onWheel={(e: any) => e.currentTarget.blur()}
                    onChange={(e: any) => {
                      setEditedQty(e?.target?.value);
                    }}
                    onKeyDown={(e: any) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];

                      if (
                        allowedKeys.includes(e.key) ||
                        (e.key >= "0" && e.key <= "9")
                      ) {
                        return;
                      }

                      e.preventDefault();
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-item">
                  <label className="custom-label mb-1 ff d-flex align-items-center justify-content-between">
                    Number of Baches
                  </label>
                  <Input
                    name="qty"
                    type="number"
                    min={0}
                    value={editedBatchesQty}
                    className="form-control form-control-lg"
                    placeholder={"Enter Quantity"}
                    onWheel={(e: any) => e.currentTarget.blur()}
                    onChange={(e: any) => {
                      setEditedBatchesQty(e?.target?.value);
                    }}
                    onKeyDown={(e: any) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];

                      if (
                        allowedKeys.includes(e.key) ||
                        (e.key >= "0" && e.key <= "9")
                      ) {
                        return;
                      }

                      e.preventDefault();
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default EditLabelDataDrawer;
